import { CollectionResponse } from '../../interfaces/api/api';
import api from '../../config/api';
import { getJsonResponse } from '../../utils/ApiUtils';
import Request, { RequestStatus, RequestType } from '../../interfaces/api/Request';
import { Order } from '../../interfaces/Table';
import useAuth from './useAuth';

const useRequest = () => {
  const { fetch } = useAuth();

  const getAll = async (
    type: RequestType | 'all',
    page: number,
    limit: number,
    orderBy = 'createdAt',
    order: Order = 'asc',
    statusFilter?: RequestStatus
  ): Promise<CollectionResponse<Request>> => {
    const { endpoint, ...options } = api.request.getAll(type, orderBy, order, page, limit, statusFilter);

    const response = await fetch(endpoint, options);

    try {
      return await getJsonResponse<CollectionResponse<Request>>(response);
    } catch (e) {
      throw new Error(e.message);
    }
  };

  const get = async (requestId: string): Promise<Request> => {
    const { endpoint, ...options } = api.request.get(requestId);

    const response = await fetch(endpoint, options);

    try {
      return await getJsonResponse<Request>(response);
    } catch (e) {
      throw new Error(e.message);
    }
  };

  const updateStatus = async (requestId: string, newStatus: string, closedReason?: string): Promise<Request> => {
    const { endpoint, ...options } = api.request.updateStatus(requestId, newStatus, closedReason);

    const response = await fetch(endpoint, options);

    try {
      return await getJsonResponse<Request>(response);
    } catch (e) {
      throw new Error(e.message);
    }
  };

  const updateIssueId = async (requestId: string, issueId: string): Promise<Request> => {
    const { endpoint, ...options } = api.request.updateIssueId(requestId, issueId);

    const response = await fetch(endpoint, options);

    try {
      return await getJsonResponse<Request>(response);
    } catch (e) {
      throw new Error(e.message);
    }
  };

  return { getAll, get, updateStatus, updateIssueId };
};

export default useRequest;
